import EventBus from '@/eventBus';

export const AjaxHelpersVue = {
  data() {
    return {
      //pageLoaded: false

      h1: ''
    }
  },

  methods: {
    /*isDev(staticUrl) {
      let hostName = window.location.hostname;

      return (hostName === 'localhost') || (hostName === staticUrl);
    },*/

    // todo потестить
    req(api, data, callback, queryType = 'common') {

      data = data || {};

      // EventBus.$emit('preloaderShow');

      PrologueClient.queryToServer(api, data, res => {

        if(!this.check404(res)) {
          EventBus.$emit('load404Page');

          return false;
        }

        if(queryType === 'common') {
          this.queryCommon(callback, res);
        }
        if(queryType === 'popup') {
          this.queryPopup(res);
        }
        if(queryType === 'form') {
          this.queryForm(callback, res);
        }

        //EventBus.$emit('preloaderHide');
      });
    },

    requestData(req, data) {
        return new Promise((resolve, reject) => {
            PrologueClient.queryToServer(req, data, res => {
                resolve(res);
            })
        })
    },

    check404(res) {
      if(this.checkProperty(res.status) && res.status == '404') {
        return false;
      }

      return true;
    },

    queryCommon(callback, res) {
      // Данные для хедера и главного меню
      EventBus.$emit('pageLoaded', {
        header: res.header,
        menuTop: res.menuTop
      });

      // Данные для футера
      //this.$store.commit('setFooter', res.footer);
      //this.$store.dispatch('setFooter', res.footer);

      // Установить meta для страницы
      if(this.checkProperty(res.meta)) {
        this.setMeta(res.meta);
      }

      // Первая загрузка
      this.setPageLoaded();

      if($.isFunction(callback)) {
        callback(res);
      }
    },

    queryPopup(res) {
      EventBus.$emit('popupDataLoaded', res);
    },

    queryForm(callback, res) {
      if($.isFunction(callback)) {
        callback(res);
      }

      // EventBus.$emit('preloaderHide');
    },

    // Выбор активного блока для страницы

    setMeta(res) {
      if(res.title.length) {
        $('title').text(res.title);
      }

      if(res.description.length) {
        $('[name="description"]').attr('content', res.description);
      }

      if(res.h1.length) {
        this.h1 = res.h1;
      }
    },

    // Для первой загрузки
    setPageLoaded() {
      let $page = $('.page');

      if(!$page.hasClass('page--loaded')) {
        $page.addClass('page--loaded');

        //this.pageLoaded = true;
      }
    },

    checkProperty(prop) {
      return typeof(prop) !== 'undefined' && $.type(prop) !== 'null';
    },

    /**
     * Проверка загрузки изображений
     * @param objImages {object}
     * @returns {Promise}
     * @description Формат принимаего объекта, где loaded - статус изображения по-умолчанию не загружен; src - ссылка на изображение
     var objImages = [
     {
       loaded: false,
       src: img1Src
     },
     {
       loaded: false,
       src: img2Src
     }
     ];
     */
    checkImgLoading(objImages) {
        // return new Promise((resolve, reject) => {
            let loaded = false;

            $.each(objImages, (i, el) => {
                $('<img />').attr('src', el.url).on('load', function() {
                    $(this).remove();

                    objImages[i].loaded = true;
                });
            });

            let int = setInterval(() => {
                $.each(objImages, (i, el) => {
                    loaded = el.loaded ? true : false;
                });

                if(loaded) {
                    clearInterval(int);
                    EventBus.$emit('imgLoaded', false);
                    // resolve();
                }
            }, 500);
        // });
    },

    checkOverflow(path) {
        if($(window).width() > 1200) {
            if (path === '/') {
                $('.page__items').css('height', '100%');
            } else {
                setTimeout(() => {
                    $('.page__items').css('height', 'unset');
                }, 300);
            }
            if (path.item) {
                $('.page').css('overflow', 'unset');
            } else {
                if (path.indexOf('/uslugi') > -1 || path === '/partnyory' || path === '/nashi-obekty' || path === '/oprosnye-listy') {
                    $('.page').css('overflow', 'unset');
                } else {
                    $('.page').css('overflow', 'hidden');
                }
            }
            if (path === '/partnyory') {
                $('.page').css('height', 'auto');
            } else {
                $('.page').css('height', '100vh');
            }
        }
        this.scrollbarCheck();
    },

    scrollbarCheck() {
        let documentWidth = parseInt($('#app').innerWidth());
        let windowsWidth = parseInt(window.innerWidth);
        let scrollbarWidth = windowsWidth - documentWidth;
        if(scrollbarWidth > 0) {
            $('.header').css('padding-left', scrollbarWidth+'px');
            $('.page__item--active').css('padding-left', scrollbarWidth+'px');
        } else {
            $('.header').css('padding-left', '0');
            $('.page__item--active').css('padding-left', '0');
        }
    }

  }
};
